import { createTheme } from '@mui/material/styles';


let theme = createTheme({
   
    typography: {
        fontFamily: [
          'Roboto Mono',
        ].join(','),
      },

      
  });
  

export default theme;